"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRawDataMappersSortToJSON = exports.GetRawDataMappersSortFromJSONTyped = exports.GetRawDataMappersSortFromJSON = exports.GetRawDataMappersSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetRawDataMappersSort;
(function (GetRawDataMappersSort) {
    GetRawDataMappersSort["CreatedAt"] = "createdAt";
})(GetRawDataMappersSort = exports.GetRawDataMappersSort || (exports.GetRawDataMappersSort = {}));
function GetRawDataMappersSortFromJSON(json) {
    return GetRawDataMappersSortFromJSONTyped(json, false);
}
exports.GetRawDataMappersSortFromJSON = GetRawDataMappersSortFromJSON;
function GetRawDataMappersSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetRawDataMappersSortFromJSONTyped = GetRawDataMappersSortFromJSONTyped;
function GetRawDataMappersSortToJSON(value) {
    return value;
}
exports.GetRawDataMappersSortToJSON = GetRawDataMappersSortToJSON;
